module.exports = __webpack_public_path__ + "img/title-bg.9549958c.png";